import axios from "axios";
import { queryParams } from "../../../utils/queryParams";

const api = axios.create({ baseURL: queryParams.apiVersion + "" });

const BASE = "pages/sales_revenue/sales_revenue_chart";

export const totalRevenueSalesApi = {
  getChart(params) {
    return api.get(BASE, { params });
  },

  getFilters(params) {
    return api.get(`${BASE}/filters`, { params });
  }
};
